import type FreeBusyType from './FreeBusyType';
import type UserAvailabilityCalendarView from 'owa-service/lib/contract/UserAvailabilityCalendarView';

interface FreeBusyRow extends UserAvailabilityCalendarView {
    // NOTE: (fpintos): I'm thinking we should be using just UserAvailabilityCalendarView
    // and these fields can be just the data we get from the service as-is instead of being processed.
    mergedFreeBusy: FreeBusyType[];
}

export default FreeBusyRow;

export function emptyFreeBusyRow(size: number, value: FreeBusyType): FreeBusyType[] {
    let result = [];
    for (let i = 0; i < size; i++) {
        result[i] = value;
    }
    return result;
}
